import { render, staticRenderFns } from "./DeleteLicenseModal.vue?vue&type=template&id=51f6aa4d"
import script from "./DeleteLicenseModal.vue?vue&type=script&lang=js"
export * from "./DeleteLicenseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51f6aa4d')) {
      api.createRecord('51f6aa4d', component.options)
    } else {
      api.reload('51f6aa4d', component.options)
    }
    module.hot.accept("./DeleteLicenseModal.vue?vue&type=template&id=51f6aa4d", function () {
      api.rerender('51f6aa4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/Licenses/DeleteLicenseModal.vue"
export default component.exports